export default class BaseScene {
    constructor(pitch) {
        this.Pitch = pitch;
        this.SoundManager = window.SoundComponent;
    }

    GetPlayer(team, playerNum) {
        if(playerNum == 0)
            return null;

        for (var index = (team == 1 ? 0 : 18); index < 18+(team == 1 ? 0 : 18); index++) {
            var playerComp = this.Pitch.players[index];
            if(playerComp.props.player.Num == playerNum) {
                return playerComp;
            }
        }

        return null;
    }

    HighLightPlayers(players) {
        let ids = [];
        players.forEach((player) => {
            if(player != null)
                ids.push(player.props.player.Id);
        });
        
        this.Pitch.highLightPlayersByIds(ids);
    }

    getPlayersByTeam(team, filter){
        let result = [];
        let players = team == 1 ? this.Pitch.players.slice(0,18) : this.Pitch.players.slice(18,36);
        players.forEach((player) => {
            if(filter == null || filter(player) && player.props.index < 11)
                result.push(player);
        });

        return result;
    }

    getPlayers(filter){
        let result = [];
        this.Pitch.players.forEach((player) => {
            if(filter == null || player != null && filter(player) && player.props.index < 11)
                result.push(player);
        });

        return result;
    }

    PlayerIn(p, players) {
        for (var index = 0; index < players.length; index++) {
            var player = players[index];
            if(player.Id == p.Id)
                return true;
        }

        return false;
    }

    processCancellation(err) {
        if(err != 'cancelled')
            throw err;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/BaseScene.js
 **/